import React from 'react'
import { Col } from 'antd'

import { RadioBtn } from '@edulastic/common'
import { test as testConstants } from '@edulastic/constants'

import { SHOW_TEXT_TO_SPEECH_FOR_PASSAGES } from '@edulastic/constants/const/test'
import {
  RadioWrapper,
  StyledAccomodationSettingContainer,
  StyledRadioGroup,
  StyledAccommodationSettingKeyTitle,
} from '../../../../TestPage/components/Setting/components/Container/styled'
import { StyledRow } from '../../SimpleOptions/styled'
import SettingContainer from '../SettingsContainer'
import DetailsTooltip from '../DetailsTooltip'
import PassageTTSSettingCheckbox from '../../../../Common/PassageTTSSettingCheckbox'
import { getTtsDescription } from '../../../../utils/accommodations'

const { accommodationsSettings } = testConstants

const { multiLanguageEnabled, textToSpeech } = accommodationsSettings

const AccommodationSettingRow = ({
  accommodationSetting,
  disabled,
  premium,
  overRideSettings,
  isNestedSetting,
  tootltipWidth,
  accommodationsData,
}) => {
  const ttsValue = accommodationsData[
    accommodationsSettings.textToSpeech.key
  ]?.settings.find((s) => s.key === accommodationsSettings.textToSpeech.key)
    ?.value

  const ttsForPassagesValue = accommodationsData[
    accommodationsSettings.textToSpeech.key
  ]?.settings.find(
    (s) => s.key === accommodationsSettings.textToSpeechForPassages.key
  )?.value

  const featureDescription =
    accommodationSetting.key === textToSpeech.key
      ? getTtsDescription(ttsValue, ttsForPassagesValue)
      : accommodationSetting.description || ''

  return (
    <SettingContainer id={accommodationSetting.id}>
      <DetailsTooltip
        width={tootltipWidth}
        title={accommodationSetting.title}
        content={featureDescription}
        premium={premium}
        placement="rightTop"
      />
      <StyledRow
        key={accommodationSetting.key}
        align="middle"
        borderBottom={isNestedSetting && 'none'}
        padding={
          isNestedSetting
            ? '12px 0px 0px 0px !important'
            : '12px 10px !important'
        }
      >
        <Col span={6}>
          <StyledAccommodationSettingKeyTitle
            isNestedSetting={isNestedSetting}
            textTransform="uppercase"
            id={`${accommodationSetting.key}-label`}
          >
            {accommodationSetting.title}
          </StyledAccommodationSettingKeyTitle>
        </Col>
        <Col span={18}>
          <StyledRadioGroup
            disabled={disabled || !premium}
            onChange={(e) => {
              if (
                accommodationSetting.key === multiLanguageEnabled.key &&
                e.target.id === `${multiLanguageEnabled.key}-student-level` &&
                !e.target.value
              ) {
                overRideSettings(accommodationSetting.key, true)
                return
              }
              overRideSettings(accommodationSetting.key, e.target.value)
            }}
            value={accommodationSetting.value}
            flex="0 0 calc(100% / 3)"
            isHorizontal
            name={`${accommodationSetting.key}-radio-group`}
            aria-labelledby={`${accommodationSetting.key}-label`}
          >
            {accommodationSetting.hasStudentLevelOption && (
              <RadioBtn
                value={
                  accommodationSetting.doNotAllowUndefined &&
                  !accommodationSetting.hasEnableOption
                    ? true
                    : undefined
                }
                data-cy={`${accommodationSetting.key}-student-level`}
                id={`${accommodationSetting.key}-student-level`}
              >
                Enable Student Level
              </RadioBtn>
            )}
            {
              <RadioBtn
                data-cy={`${accommodationSetting.key}-enable`}
                value
                id={`${accommodationSetting.key}-enable`}
                style={{visibility: accommodationSetting.hasEnableOption ? 'visible': 'hidden'}}
              >
                ENABLE ALL
              </RadioBtn>
            }
            <RadioBtn
              data-cy={`${accommodationSetting.key}-disable`}
              value={false}
              id={`${accommodationSetting.key}-disable`}
            >
              DISABLE ALL
            </RadioBtn>
          </StyledRadioGroup>
        </Col>
      </StyledRow>
    </SettingContainer>
  )
}

const Accommodations = ({
  disabled,
  overRideSettings,
  premium,
  accommodationsData,
  tootltipWidth,
}) => {
  return (
    <RadioWrapper
      disabled={disabled}
      style={{
        marginTop: '20px',
        marginBottom: 0,
        flexDirection: 'row',
      }}
    >
      {Object.keys(accommodationsData).map((key) => {
        const { settings, title = '' } = accommodationsData[key]
        const ttsValue = accommodationsData[key].settings.find(
          (s) => s.key === accommodationsSettings.textToSpeech.key
        )?.value
        return (
          <React.Fragment key={key}>
            {settings.length > 1 ? (
              <StyledAccomodationSettingContainer>
                <StyledAccommodationSettingKeyTitle>
                  {title}
                </StyledAccommodationSettingKeyTitle>
                {settings.map((setting) => {
                  if (setting.key === SHOW_TEXT_TO_SPEECH_FOR_PASSAGES) {
                    return (
                      <StyledRow
                        borderBottom="none"
                        padding="8px 0px !important"
                      >
                        {[true, undefined].includes(ttsValue) && (
                          <>
                            <Col span={ttsValue === true ? 12 : 6} />
                            <Col span={ttsValue === true ? 12 : 18}>
                              <PassageTTSSettingCheckbox
                                key={setting.key}
                                setting={setting}
                                accommodationsData={accommodationsData}
                                overRideSettings={overRideSettings}
                                checked={setting.value}
                                disabled={disabled}
                                showTooltip
                                tootltipWidth={tootltipWidth}
                                premium={premium}
                              />
                            </Col>
                          </>
                        )}
                      </StyledRow>
                    )
                  }
                  return (
                    <AccommodationSettingRow
                      key={setting.key}
                      accommodationSetting={setting}
                      disabled={disabled}
                      premium={premium}
                      overRideSettings={overRideSettings}
                      tootltipWidth={tootltipWidth}
                      accommodationsData={accommodationsData}
                      isNestedSetting
                    />
                  )
                })}
              </StyledAccomodationSettingContainer>
            ) : (
              <AccommodationSettingRow
                key={settings[0].key}
                accommodationSetting={settings[0]}
                disabled={disabled}
                premium={premium}
                overRideSettings={overRideSettings}
                tootltipWidth={tootltipWidth}
                accommodationsData={accommodationsData}
              />
            )}
          </React.Fragment>
        )
      })}
    </RadioWrapper>
  )
}

export default Accommodations
